import theme from "antd/lib/theme";
import { useTranslation } from "react-i18next";

import { Status, getColorByStatus } from "../ClassroomRepartition";

export const ClassroomRepartitionLegend = () => {
    return (
        <div className="ant-sm mt-ant-xs flex flex-wrap items-center justify-center gap-ant-sm">
            <ClassroomRepartitionLegendItem status={Status.UNASSIGNED} />
            <ClassroomRepartitionLegendItem status={Status.ASSIGNED} />
            <ClassroomRepartitionLegendItem status={Status.CORRECTED} />
        </div>
    );
};

const ClassroomRepartitionLegendItem = ({ status }: { status: Status }) => {
    const { token } = theme.useToken();

    const [t] = useTranslation(undefined, { keyPrefix: "component.dashboard.ClassroomRepartition" });

    return (
        <div className="flex items-center">
            <div
                className="mr-ant-xxs size-3 rounded-ant-lg"
                style={{ backgroundColor: getColorByStatus(status, token) }}
            />
            <p className="text-[11px]">{t(status)}</p>
        </div>
    );
};
